import { render, staticRenderFns } from "./RestoreVersion.vue?vue&type=template&id=d02344c6"
import script from "./RestoreVersion.vue?vue&type=script&lang=js"
export * from "./RestoreVersion.vue?vue&type=script&lang=js"
import style0 from "./RestoreVersion.vue?vue&type=style&index=0&id=d02344c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports